<div class="report-container" *ngIf="isVisible && report" [ngClass]="report.colorClass">
    <div class="report-bg-decoration"></div>

    <div class="report-header">
        <div class="header-content">
            <mat-icon class="status-icon">{{ report.icon }}</mat-icon>
            <span class="report-title">{{ report.title }}</span>
        </div>
    </div>

    <div class="report-body">
        <div class="main-stat">
            <span class="stat-label" *ngIf="report.type === 'POSITIVE'">SAVED</span>
            <span class="stat-label" *ngIf="report.type === 'NEGATIVE'">OVER</span>
            <span class="stat-value">₹{{ report.amount | number:'1.0-0' }}</span>
        </div>

        <div class="report-message">
            {{ report.message }}
        </div>

        <div class="suggestion-box">
            <mat-icon class="idea-icon">lightbulb</mat-icon>
            <span class="suggestion-text">{{ report.suggestion }}</span>
        </div>
    </div>
</div>